import { render, staticRenderFns } from "./Serve.vue?vue&type=template&id=fb30651c&scoped=true&"
import script from "./Serve.vue?vue&type=script&lang=js&"
export * from "./Serve.vue?vue&type=script&lang=js&"
import style0 from "./Serve.vue?vue&type=style&index=0&id=fb30651c&scoped=true&lang=less&"
import style1 from "./Serve.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb30651c",
  null
  
)

export default component.exports